import { AVAILABILITY_IMAGE_MAX_RANGE_DAYS, AVAILABILITY_IMAGE_MULTI_DAY_LABELS } from '../constants/bookingConst';
import { addDaysToKey, clampAvailabilityRange } from '../utils/availabilityRangeUtil';

/**
 * "From" / "To" date inputs for the Availability images dialog. One date
 * gives the usual single-day images; a range (up to
 * AVAILABILITY_IMAGE_MAX_RANGE_DAYS) gives one combined multi-day image.
 *
 * @param {object} props
 * @param {{start: string, end: string}} props.value - 'yyyy-MM-dd' dates
 * @param {(next: {start: string, end: string}) => void} props.onChange - always a valid range
 * @param {string} [props.minDate] - earliest pickable date, 'yyyy-MM-dd'
 * @param {boolean} [props.disabled]
 * @returns {JSX.Element}
 */
function AvailabilityDateRangePicker({ value, onChange, minDate = '', disabled = false }) {
  /**
   * Applies one input's new date. A cleared input (some browsers allow it)
   * is ignored rather than leaving the range half-empty.
   * @param {'start'|'end'} which
   * @param {string} picked - 'yyyy-MM-dd' or ''
   * @returns {void}
   */
  const handlePick = (which, picked) => {
    if (!picked) return;
    // A typed date can get past the input's min; hold it to the floor too.
    const date = minDate && picked < minDate ? minDate : picked;
    onChange(clampAvailabilityRange({ ...value, [which]: date }, which));
  };

  return (
    <div className="aim-range">
      <div className="aim-range-fields">
        <label className="aim-range-field">
          <span className="aim-range-label">{AVAILABILITY_IMAGE_MULTI_DAY_LABELS.RANGE_FROM}</span>
          <input
            type="date"
            className="aim-range-input"
            value={value.start}
            min={minDate || undefined}
            disabled={disabled}
            onChange={e => handlePick('start', e.target.value)}
          />
        </label>
        <label className="aim-range-field">
          <span className="aim-range-label">{AVAILABILITY_IMAGE_MULTI_DAY_LABELS.RANGE_TO}</span>
          <input
            type="date"
            className="aim-range-input"
            value={value.end}
            min={value.start || minDate || undefined}
            max={addDaysToKey(value.start, AVAILABILITY_IMAGE_MAX_RANGE_DAYS - 1)}
            disabled={disabled}
            onChange={e => handlePick('end', e.target.value)}
          />
        </label>
      </div>
      <p className="aim-range-hint">{AVAILABILITY_IMAGE_MULTI_DAY_LABELS.RANGE_HINT}</p>
    </div>
  );
}

export default AvailabilityDateRangePicker;
